// See for details:
// https://stackoverflow.com/questions/32545632

export default ({ blob, filenameWithExtension }) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filenameWithExtension;
  document.body.appendChild(a);
  a.click();
  a.remove();
};
